import { render } from "./RequisiteSumProgress.vue?vue&type=template&id=90b59958&ts=true"
import script from "./RequisiteSumProgress.vue?vue&type=script&lang=ts"
export * from "./RequisiteSumProgress.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__